import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ComponentsModule } from '../../components/components.module';
import { SupersetDashboardComponent } from './superset-dashboard.component';

@NgModule({
    declarations: [SupersetDashboardComponent],
    exports: [SupersetDashboardComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ProgressSpinnerModule,
        ComponentsModule,
    ]
})
export class DashboardModule { }
